import {html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import style from '../../../../../scss/textInput.scss';
import {FormElement} from './formElement';

@customElement('arc-number')
export class Number extends FormElement {

	static properties = {
		...FormElement.properties,
		multiline: {type: Boolean},
	};

	static styles = [...FormElement.styles, style];

	initialValue = 0;

	handleValueChange(e) {
		const numberValue = parseFloat(e.target.value);
		this.dispatchValueChange(numberValue);
	}
	render() {
		if (!this.edit) {
			return html`
				<div>
					<div class="textInputInfo">
						<div class="title">${this.title}</div>
					</div>
					<p class="value">${this.value ?? ''}</p>
				</div>
			`;
		}
		return html`
			<div class="formField ${classMap({errors: this.hasErrors(), changed: this.inputHasChanged(), disabled: this.disabled})}">
				<div class="textInputInfo">
					<div class="title">
						${this.title} ${when(this.required, () => html`<span class="requiredMark">*</span>`)}
					</div>
					${when(this.tooltip, () => html`
						<arc-tooltip text=${this.tooltip}></arc-tooltip>`)}
				</div>
				<input
					type="number"
					?required="${this.required}"
					?disabled=${this.disabled}
					placeholder="${this.placeholder}"
					.value=${this.value ?? ''}
					@input=${this.handleValueChange}
				/>
				${when(this.hasErrors(), () => html`<arc-errors .errors=${this.errors}></arc-errors>`)}
			</div>
    `;
	}
}
